export const BLACKLISTED_PAGES = ['/ekyc', '/ekyc/apply'];
